"use client";
import { useSession } from "next-auth/react";

/**
 * React hook to retrieve the current user on the client.
 */
export function useCurrentUser() {
  const sessionHook = useSession();
  const session = sessionHook?.data;
  return session?.user;
}
